/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Directory_Search_City_PeopleInputs */

const en_directory_search_city_people = /** @type {(inputs: Directory_Search_City_PeopleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Specialists: ${i?.count}`)
};

const pl_directory_search_city_people = /** @type {(inputs: Directory_Search_City_PeopleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Specjaliści: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Specialists: {count}" |
*
* @param {Directory_Search_City_PeopleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_city_people = /** @type {((inputs: Directory_Search_City_PeopleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_City_PeopleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_city_people(inputs)
	return en_directory_search_city_people(inputs)
});